module.exports = __webpack_public_path__ + "img/empty.8a65504b.png";